import classes from "./index.module.scss";
import Container from "../Container";
import Title from "../Title";
import { timeline } from "../data";
import { v4 as uuid } from "uuid";
import { ReactComponent as Line } from "../images/line.svg";
import Card from "./Card";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { useEffect } from "react";

gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

gsap.config({
  force3D: false,
  nullTargetWarn: false,
  z: 0.1,
  rotationZ: 0.01,
  transformPerspective: 1000,
});

export default function Timeline() {
  const animation = () => {
    const tl = gsap
      .timeline({
        scrollTrigger: {
          trigger: `.${classes.body}`,
          scrub: true,
          start: "top 50%",
          end: "bottom 0%",
        },
      })
      .to(".history-ball", { duration: 0.01, autoAlpha: 1 })
      .to(
        ".history-ball",
        {
          motionPath: {
            path: ".history-line",
            align: ".history-line",
            alignOrigin: [0.5, 0.5],
          },
        },
        0
      );
    return tl;
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      animation();
    }, 500);
    return () => {
      clearTimeout(timeout);
      animation().kill();
    };
  }, []);

  return (
    <section>
      <Container>
        <div className={classes.body}>
          <Title>With a history</Title>
          <div className={classes.timeline}>
            <ul className={classes.list}>
              {timeline.map(({ year, text }, index) => (
                <li key={uuid()} className={`${classes.list__item}`}>
                  <Card year={year} text={text} />
                </li>
              ))}
            </ul>
            <div className={classes.line}>
              <Line />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
